import { BLOG_TAGS } from './blog-tags';

// Fixed allowed values of the Contentful blogPost.tags field, shared with the migration that
// declares them. Used by the /blog tag filter and the related-articles query.
export { BLOG_TAGS };

export type BlogTag = (typeof BLOG_TAGS)[number];

// Display label of each tag. Explicit rather than title-cased from the slug, so wording stays
// editable without touching the slugs the URLs and Contentful validation depend on.
const BLOG_TAG_LABELS: Record<BlogTag, string> = {
  'tracking-tips': 'Tracking Tips',
  'shopping-tips': 'Shopping Tips',
  trends: 'Trends',
  'international-shopping': 'International Shopping',
  'courier-guides': 'Courier Guides',
};

/** Falls back to a title-cased slug so a tag added in Contentful ahead of the code still reads well. */
export const getBlogTagLabel = (tag: string): string =>
  BLOG_TAG_LABELS[tag as BlogTag] ?? tag.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

export const BLOG_PAGE_SIZE = 12;

export const RELATED_POSTS_LIMIT = 3;

/**
 * Copy of the /blog section, hardcoded in English on purpose: the blog is English-only in v1 and
 * has no translation entries yet, and `t()` renders an unknown key as the key itself ("blog_title").
 * Move to MasterTranslation once the keys exist.
 */
export const BLOG_COPY = {
  title: 'Tracking Guides & Insights',
  description: 'Parcel tracking guides, carrier explainers and delivery tips to help you find your order faster.',
  allTags: 'All',
  noPosts: 'No articles yet.',
  relatedArticles: 'Related articles',
};
